export default __webpack_public_path__ + "static/media/photo--lg--kara3.e17629a0.jpg";